module.exports = __webpack_public_path__ + "img/7.708fb562.png";